const ERROR_MESSAGE_KEYS = [
  {
    matches: (message) => /^Invalid Excel keys\. Missing keys:/i.test(message),
    resolve: (message) => ({
      key: 'library-feedback-upload-invalid-keys',
      values: {
        keys: message.replace(/^Invalid Excel keys\. Missing keys:\s*/i, '').trim(),
      },
    }),
  },
  {
    matches: (message) => message.includes('does not have permission for this country/language'),
    key: 'translation-error-country-language-permission',
  },
  {
    matches: (message) => message === 'Only pending files can be deleted',
    key: 'translation-error-file-pending-only',
  },
  {
    matches: (message) => message.startsWith('File not found'),
    key: 'translation-error-file-not-found',
  },
];

const getTranslationApiErrorMessage = (error, t, fallbackKey) => {
  if (error.response?.status === 409) return t('alert-duplicate');

  const responseData = error.response?.data;
  const backendMessage = typeof responseData === 'string'
    ? responseData
    : responseData?.message || responseData?.error || '';
  const matchingError = ERROR_MESSAGE_KEYS.find(({ matches }) => matches(backendMessage));

  if (matchingError?.resolve) {
    const resolved = matchingError.resolve(backendMessage);
    return t(resolved.key, resolved.values);
  }

  return t(matchingError?.key || fallbackKey);
};

export default getTranslationApiErrorMessage;
